import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "getting-started-with-adobe-io-runtime"
    }}>{`Getting Started with Adobe I/O Runtime`}</h1>
    <p>{`If you`}{`’`}{`ve read the `}<a parentName="p" {...{
        "href": "../overview/what_is_runtime.md"
      }}>{`introductory documentation`}</a>{`, then you`}{`’`}{`re already familiar with the Runtime concept: an easy way to run code on demand on Adobe Experience Cloud and integrate with Adobe`}{`’`}{`s cloud services without the effort of managing servers and the expense of always-on computing resources.  `}</p>
    <p>{`If you're an existing Adobe enterprise customer, Runtime is available as a 6 month trial or to purchase. Please visit our `}<a parentName="p" {...{
        "href": "../overview/getting_access.md"
      }}>{`getting access`}</a>{` page for more details. Once you have access to Runtime, you can log into the Adobe I/O Console, create a new project, and add Runtime to that project. All actions you run on Runtime are executed within a namespace associated with a project. When you create your new project, you'll get an authorization key that you can use to create and manage your actions.`}</p>
    <p>{`Once you have an authorization key and an integration with a namespace created, you`}{`’`}{`ll need to install the OpenWhisk CLI. Then, you can get started building applications on the system:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "setup.md"
        }}>{`Setting up your environment`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "deploy.md"
        }}>{`Deploy and invoke your first action`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "activations.md"
        }}>{`Retrieve Action Invocation Results`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      